import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "dd_amb_token";

export const getToken = () => localStorage.getItem(KEY) || "";
export const setToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));
export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

/** FastAPI 422 details are arrays — flatten to a readable string. */
export const apiError = (err, fallback = "Something went wrong. Please try again.") => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? `${(e.loc || []).slice(-1)[0] || ""}: ${e.msg}`.replace(/^: /, "") : JSON.stringify(e))).join(" ");
  return d.msg || String(d);
};

/** Current ambassador: undefined = loading, null = signed out, object = signed in. */
export const useAmbassador = () => {
  const [amb, setAmb] = useState(getToken() ? undefined : null);
  const refresh = useCallback(async () => {
    if (!getToken()) return setAmb(null);
    try {
      const r = await axios.get(`${API}/ambassadors/me`, { headers: authHeaders() });
      setAmb(r.data);
    } catch {
      setToken("");
      setAmb(null);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const signOut = () => { setToken(""); setAmb(null); };
  return { amb, setAmb, refresh, signOut };
};

export const input = "w-full h-12 px-4 rounded-xl bg-[#ffffff] border border-[#e3e2dc] text-sm outline-none focus:border-[#ff2a85]/60 transition-colors";
export const area = `${input} h-28 py-3 resize-none`;
export const lbl = "block font-mono-d text-[9px] uppercase tracking-[0.2em] text-[#5f5e5a] mb-1.5";
export const primaryBtn = "h-13 w-full rounded-full bg-[#0a0a0b] hover:bg-[#ff2a85] disabled:opacity-50 text-white font-mono-d text-[11px] uppercase tracking-[0.2em] transition-colors flex items-center justify-center gap-2 px-6 py-4";
export const money = (cents) => `$${((cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const PLATFORMS = [["instagram", "Instagram"], ["tiktok", "TikTok"], ["youtube", "YouTube"], ["x", "X / Twitter"], ["facebook", "Facebook"], ["snapchat", "Snapchat"], ["whatsapp", "WhatsApp groups"], ["podcast", "Podcast"], ["blog", "Blog / website"], ["other", "Other"]];
